import { LeaveOfAbsence as LegacyLeaveOfAbsence } from '../../../models/LeaveOfAbsence'
import { LeaveOfAbsenceStatus } from '../../types'
import { transformToPeriod } from '../Period/PeriodTransformers'
import { LegacyBasicUser } from '../User/User'
import { transformToBasicUser } from '../User/UserTransformers'
import { LeaveOfAbsence, LeaveOfAbsenceResource, LeaveOfAbsenceV3Resource } from './LeaveOfAbsence'

export const transformToLeaveOfAbsence = (
    resource: LeaveOfAbsenceResource,
    user: LegacyBasicUser,
): LeaveOfAbsence => ({
    id: resource.id,
    status: resource.attributes.status,
    reason: resource.attributes.reason,
    declineReason: resource.attributes.declineReason,
    period: transformToPeriod(new Date(resource.attributes.start), new Date(resource.attributes.end)),
    user,
    changeset: resource.attributes.changeset ?? null,
})

export const transformV3ResourceToLeaveOfAbsence = (
    resource: LeaveOfAbsenceV3Resource,
    user: LegacyBasicUser,
): LeaveOfAbsence => ({
    id: resource.uuid,
    status: resource.status,
    reason: resource.reason,
    declineReason: resource.declineReason,
    period: transformToPeriod(new Date(resource.startTime), new Date(resource.endTime)),
    user,
    changeset: resource.changeset ?? null,
})

export const transformLegacyLeaveOfAbsenceToLeaveOfAbsence = (
    leaveOfAbsence: LegacyLeaveOfAbsence,
): LeaveOfAbsence => ({
    id: leaveOfAbsence.id,
    status: leaveOfAbsence.status as LeaveOfAbsenceStatus,
    reason: leaveOfAbsence.reason,
    declineReason: leaveOfAbsence.declineReason,
    period: {
        start: leaveOfAbsence.start,
        end: leaveOfAbsence.end,
    },
    user: transformToBasicUser({ type: 'users', id: leaveOfAbsence.user.id, attributes: leaveOfAbsence.user }),
    changeset: leaveOfAbsence.changeset ?? null,
})
